var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { useAPI } from "@/hooks/useAPI";
import { useRecoilValue } from "recoil";
import { merchantState } from "@/views/Home/state";
import toast from "react-hot-toast";
import DashboardLayout from "@/views/Layout/DashboardLayout";
import PhoneInput from "react-phone-number-input/input";
import CanAccess from "@/components/CanAccess";
import { Roles } from "@/enums/Roles";
import { useNavigate } from "react-router-dom";
var HERE_API_KEY = (_a = process.env.MIX_HERE_MAP_API_KEY) !== null && _a !== void 0 ? _a : "";
function parseAddressLabel(label) {
    var postcodeMatch = label ? label.match(/\b([A-Z]{2}\d{4})\b/) : null;
    var postalCode = postcodeMatch ? postcodeMatch[1] : "";
    var city = "";
    if (postcodeMatch) {
        var beforePostcode = label.substring(0, postcodeMatch.index).trim().replace(/,\s*$/, "");
        var lastComma = beforePostcode.lastIndexOf(",");
        city = lastComma >= 0 ? beforePostcode.substring(lastComma + 1).trim() : beforePostcode;
    }
    return { city: city, postalCode: postalCode };
}
function detectDistrictFromPostcode(postalCode) {
    if (!postalCode)
        return null;
    var prefix = postalCode.substring(0, 2).toUpperCase();
    var districts = {
        "Brunei-Muara": ["BA", "BB", "BC", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BK", "BL", "BM", "BP", "BS", "BT", "BU"],
        "Belait": ["KA", "KB", "KE", "KG", "KH", "KM", "KN"],
        "Tutong": ["TA", "TB", "TE", "TF", "TG"],
        "Temburong": ["PA", "PB", "PK"],
    };
    for (var _i = 0, _a = Object.entries(districts); _i < _a.length; _i++) {
        var _b = _a[_i], district = _b[0], prefixes = _b[1];
        if (prefixes.includes(prefix))
            return district;
    }
    return null;
}
export default function MerchantStoreCreatePage() {
    var _this = this;
    var hitAPI = useAPI();
    var navigate = useNavigate();
    var merchant = useRecoilValue(merchantState);
    var _a = useState(1), type = _a[0], setType = _a[1];
    var _b = useState(""), phone = _b[0], setPhone = _b[1];
    // HERE Maps state
    var _c = useState(""), latitude = _c[0], setLatitude = _c[1];
    var _d = useState(""), longitude = _d[0], setLongitude = _d[1];
    var _e = useState(""), address = _e[0], setAddress = _e[1];
    var _f = useState("Brunei-Muara"), district = _f[0], setDistrict = _f[1];
    var _g = useState(""), city = _g[0], setCity = _g[1];
    var _h = useState(""), postcode = _h[0], setPostcode = _h[1];
    var _j = useState(""), addressSearch = _j[0], setAddressSearch = _j[1];
    var _k = useState([]), suggestions = _k[0], setSuggestions = _k[1];
    var _l = useState(false), showSuggestions = _l[0], setShowSuggestions = _l[1];
    var _m = useState(false), searchLoading = _m[0], setSearchLoading = _m[1];
    var _o = useState(false), mapReady = _o[0], setMapReady = _o[1];
    var mapRef = useRef(null);
    var hereMapRef = useRef(null);
    var hereMarkerRef = useRef(null);
    var searchTimeoutRef = useRef(null);
    var suggestionsRef = useRef(null);
    // Load HERE Maps scripts dynamically
    useEffect(function () {
        if (!HERE_API_KEY)
            return;
        var scriptIds = ["here-core", "here-service", "here-ui", "here-events"];
        var scriptUrls = [
            "https://js.api.here.com/v3/3.1/mapsjs-core.js",
            "https://js.api.here.com/v3/3.1/mapsjs-service.js",
            "https://js.api.here.com/v3/3.1/mapsjs-ui.js",
            "https://js.api.here.com/v3/3.1/mapsjs-mapevents.js",
        ];
        var loadedCount = 0;
        var total = scriptUrls.length;
        if (!document.getElementById("here-ui-css")) {
            var link = document.createElement("link");
            link.id = "here-ui-css";
            link.rel = "stylesheet";
            link.href = "https://js.api.here.com/v3/3.1/mapsjs-ui.css";
            document.head.appendChild(link);
        }
        var loadScript = function (url, scriptId, onLoad) {
            if (document.getElementById(scriptId)) {
                onLoad();
                return;
            }
            var script = document.createElement("script");
            script.id = scriptId;
            script.src = url;
            script.async = false;
            script.onload = onLoad;
            document.head.appendChild(script);
        };
        var loadNext = function (index) {
            if (index >= total) {
                setMapReady(true);
                return;
            }
            loadScript(scriptUrls[index], scriptIds[index], function () {
                loadedCount++;
                loadNext(index + 1);
            });
        };
        loadNext(0);
    }, []);
    // Initialize map once scripts are ready
    useEffect(function () {
        if (!mapReady || !mapRef.current || !window.H || !HERE_API_KEY)
            return;
        var H = window.H;
        var center = { lat: 4.9031, lng: 114.9398 };
        var platform = new H.service.Platform({ apikey: HERE_API_KEY });
        var defaultLayers = platform.createDefaultLayers();
        mapRef.current.innerHTML = "";
        var map = new H.Map(mapRef.current, defaultLayers.vector.normal.map, {
            center: center,
            zoom: 15,
            pixelRatio: window.devicePixelRatio || 1,
        });
        var behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
        H.ui.UI.createDefault(map, defaultLayers);
        var marker = new H.map.Marker(center, { volatility: true });
        marker.draggable = true;
        map.addObject(marker);
        map.addEventListener("dragstart", function (ev) {
            if (ev.target instanceof H.map.Marker)
                behavior.disable();
        });
        map.addEventListener("dragend", function (ev) {
            if (ev.target instanceof H.map.Marker) {
                behavior.enable();
                var pos = ev.target.getGeometry();
                setLatitude(pos.lat.toFixed(6));
                setLongitude(pos.lng.toFixed(6));
            }
        });
        map.addEventListener("drag", function (ev) {
            var target = ev.target;
            var pointer = ev.currentPointer;
            if (target instanceof H.map.Marker) {
                target.setGeometry(map.screenToGeo(pointer.viewportX, pointer.viewportY));
            }
        });
        map.addEventListener("tap", function (event) {
            var coord = map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
            marker.setGeometry({ lat: coord.lat, lng: coord.lng });
            setLatitude(coord.lat.toFixed(6));
            setLongitude(coord.lng.toFixed(6));
        });
        window.addEventListener("resize", function () {
            map.getViewPort().resize();
        });
        hereMapRef.current = map;
        hereMarkerRef.current = marker;
        return function () {
            map.dispose();
            hereMapRef.current = null;
            hereMarkerRef.current = null;
        };
    }, [mapReady]);
    // Close suggestions on outside click
    useEffect(function () {
        var handleClick = function (e) {
            if (suggestionsRef.current &&
                !suggestionsRef.current.contains(e.target)) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener("click", handleClick);
        return function () { return document.removeEventListener("click", handleClick); };
    }, []);
    var searchAddress = function (query) { return __awaiter(_this, void 0, void 0, function () {
        var response, data, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setSearchLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, hitAPI("/merchant/heremap/autosuggest-search", "POST", { query: query })];
                case 2:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _b.sent();
                    if (data.items) {
                        setSuggestions(data.items);
                        setShowSuggestions(true);
                    }
                    else {
                        setSuggestions([]);
                        setShowSuggestions(true);
                    }
                    return [3 /*break*/, 6];
                case 4:
                    _a = _b.sent();
                    setSuggestions([]);
                    return [3 /*break*/, 6];
                case 5:
                    setSearchLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleAddressSearchChange = function (e) {
        var query = e.target.value;
        setAddressSearch(query);
        if (searchTimeoutRef.current)
            clearTimeout(searchTimeoutRef.current);
        if (query.trim().length < 2) {
            setShowSuggestions(false);
            return;
        }
        searchTimeoutRef.current = setTimeout(function () { return searchAddress(query.trim()); }, 250);
    };
    var handleSuggestionClick = function (item) {
        var _a, _b, _c, _d, _e, _f;
        var lat = item.position.lat;
        var lng = item.position.lng;
        var addressLabel = (_b = (_a = item.address) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : item.title;
        var parsed = parseAddressLabel(addressLabel);
        var itemCity = (_d = (_c = item.address) === null || _c === void 0 ? void 0 : _c.city) !== null && _d !== void 0 ? _d : parsed.city;
        var itemPostalCode = (_f = (_e = item.address) === null || _e === void 0 ? void 0 : _e.postalCode) !== null && _f !== void 0 ? _f : parsed.postalCode;
        setAddressSearch(addressLabel);
        setShowSuggestions(false);
        setLatitude(lat.toFixed(6));
        setLongitude(lng.toFixed(6));
        setAddress(addressLabel);
        if (itemCity)
            setCity(itemCity);
        if (itemPostalCode)
            setPostcode(itemPostalCode);
        var detectedDistrict = detectDistrictFromPostcode(itemPostalCode);
        if (detectedDistrict)
            setDistrict(detectedDistrict);
        if (hereMapRef.current && hereMarkerRef.current) {
            hereMarkerRef.current.setGeometry({ lat: lat, lng: lng });
            hereMapRef.current.setCenter({ lat: lat, lng: lng });
            hereMapRef.current.setZoom(15);
        }
    };
    var handleSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var formData, response, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    toast.loading("Creating store...", {
                        id: "create-store",
                    });
                    if (!merchant)
                        return [2 /*return*/];
                    formData = new FormData(e.currentTarget);
                    return [4 /*yield*/, hitAPI("/merchant/".concat(merchant.id, "/stores"), "POST", formData, true)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (response.status === 200) {
                        navigate("/merchant/settings");
                        toast.remove("create-store");
                    }
                    else {
                        toast.error(data.message);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(_Fragment, { children: _jsx(DashboardLayout, { title: "Stores", children: _jsxs("div", { className: "bg-white rounded-2xl py-6", style: {
                    boxShadow: "2px 4px 6px 0px rgba(72, 83, 73, 0.04)",
                }, children: [_jsx("div", { className: "flex items-center gap-4 justify-between px-5", children: _jsx("h1", { className: "text-xl text-[#123750]", children: "Create New Store" }) }), _jsx("div", { className: "px-5 py-4", children: _jsx("p", { className: "font-medium text-xs text-[#858585]", children: "Let your customer know where to find you!" }) }), _jsxs("form", { onSubmit: handleSubmit, children: [_jsxs("div", { className: "flex w-full flex-col gap-4 px-5 text-[#858585] lg:max-w-[75%]", children: [_jsxs("div", { className: "grid grid-cols-1 items-start gap-2 sm:grid-cols-2 sm:items-center sm:gap-4", children: [_jsxs("label", { className: "font-medium text-xs", children: ["Type", _jsx("span", { className: "text-[#EB5757]", children: "*" })] }), _jsxs("select", { name: "type", className: "border border-[#B5B5C3] rounded-sm text-xs py-2 px-4", required: true, value: type, onChange: function (e) { return setType(+e.target.value); }, children: [_jsx("option", { value: 1, children: "Physical store" }), _jsx("option", { value: 2, children: "Online store" })] })] }), type === 1 && (_jsxs(_Fragment, { children: [_jsxs("div", { className: "grid grid-cols-1 items-start gap-2 sm:grid-cols-2 sm:items-center sm:gap-4", children: [_jsxs("label", { className: "font-medium text-xs", children: ["Store Name", _jsx("span", { className: "text-[#EB5757]", children: "*" })] }), _jsx("input", { type: "text", name: "name", className: "border border-[#B5B5C3] rounded-sm text-xs py-2 px-4", placeholder: "Enter store name" })] }), _jsxs("div", { className: "col-span-2", children: [_jsx("label", { className: "font-medium text-xs block mb-2", children: "Location" }), _jsxs("div", { className: "relative mb-3", ref: suggestionsRef, children: [_jsx("input", { type: "text", className: "w-full border border-[#B5B5C3] rounded-sm text-xs py-2 px-4", placeholder: "Search for an address...", autoComplete: "off", value: addressSearch, onChange: handleAddressSearchChange }), showSuggestions && (_jsx("div", { className: "absolute top-full left-0 right-0 bg-white border border-[#E4E6EF] rounded shadow-lg z-50 max-h-[240px] overflow-y-auto", children: searchLoading ? (_jsx("div", { className: "px-4 py-3 text-xs text-[#7E8299] text-center", children: "Searching..." })) : suggestions.length === 0 ? (_jsx("div", { className: "px-4 py-3 text-xs text-[#7E8299] text-center", children: "No results found in Brunei" })) : (suggestions.map(function (item, index) {
                                                                    var _a, _b;
                                                                    var addressLabel = (_b = (_a = item.address) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : item.title;
                                                                    return (_jsxs("div", { className: "px-4 py-2 cursor-pointer border-b border-[#F3F6F9] last:border-b-0 hover:bg-[#F9FAFB]", onClick: function () { return handleSuggestionClick(item); }, children: [_jsx("div", { className: "text-xs font-semibold text-[#181C32]", children: item.title }), addressLabel !== item.title && (_jsx("div", { className: "text-xs text-[#7E8299]", children: addressLabel }))] }, index));
                                                                })) }))] }), HERE_API_KEY ? (_jsx("div", { ref: mapRef, className: "w-full mb-3 border-2 border-[#E4E6EF] rounded-lg bg-[#F9FAFB]", style: { height: "300px" }, children: _jsx("div", { className: "flex items-center justify-center h-full", children: _jsx("p", { className: "text-xs text-[#858585]", children: mapReady ? "Loading map..." : "Search an address above or click on the map to set location" }) }) })) : (_jsx("div", { className: "w-full mb-3 border-2 border-[#E4E6EF] rounded-lg bg-[#F9FAFB] flex items-center justify-center", style: { height: "300px" }, children: _jsx("p", { className: "text-xs text-[#EB5757]", children: "Map not available (API key not configured)" }) })), _jsx("p", { className: "text-xs text-[#858585] mb-3", children: "Search address above or click on map to pin the location" }), _jsxs("div", { className: "mb-3 grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-4", children: [_jsxs("div", { children: [_jsx("label", { className: "font-medium text-xs block mb-1", children: "Latitude" }), _jsx("input", { type: "text", name: "latitude", className: "w-full border border-[#B5B5C3] rounded-sm text-xs py-2 px-4 bg-[#F9FAFB]", placeholder: "4.9031", value: latitude, readOnly: true })] }), _jsxs("div", { children: [_jsx("label", { className: "font-medium text-xs block mb-1", children: "Longitude" }), _jsx("input", { type: "text", name: "longitude", className: "w-full border border-[#B5B5C3] rounded-sm text-xs py-2 px-4 bg-[#F9FAFB]", placeholder: "114.9398", value: longitude, readOnly: true })] })] })] }), _jsxs("div", { className: "grid grid-cols-1 items-start gap-2 sm:grid-cols-2 sm:items-center sm:gap-4", children: [_jsxs("label", { className: "font-medium text-xs", children: ["Address", _jsx("span", { className: "text-[#EB5757]", children: "*" })] }), _jsx("input", { type: "text", name: "address", className: "border border-[#B5B5C3] rounded-sm text-xs py-2 px-4", placeholder: "Enter address", value: address, onChange: function (e) { return setAddress(e.target.value); } })] }), _jsxs("div", { className: "grid grid-cols-1 items-start gap-2 sm:grid-cols-2 sm:items-center sm:gap-4", children: [_jsxs("label", { className: "font-medium text-xs", children: ["District", _jsx("span", { className: "text-[#EB5757]", children: "*" })] }), _jsxs("select", { name: "district", className: "border border-[#B5B5C3] rounded-sm text-xs py-2 px-4", required: true, value: district, onChange: function (e) { return setDistrict(e.target.value); }, children: [_jsx("option", { value: "Brunei-Muara", children: "Brunei-Muara" }), _jsx("option", { value: "Tutong", children: "Tutong" }), _jsx("option", { value: "Belait", children: "Belait" }), _jsx("option", { value: "Temburong", children: "Temburong" })] })] }), _jsxs("div", { className: "grid grid-cols-1 items-start gap-2 sm:grid-cols-2 sm:items-center sm:gap-4", children: [_jsxs("label", { className: "font-medium text-xs", children: ["City", _jsx("span", { className: "text-[#EB5757]", children: "*" })] }), _jsx("input", { type: "text", name: "city", className: "border border-[#B5B5C3] rounded-sm text-xs py-2 px-4", placeholder: "Enter city", value: city, onChange: function (e) { return setCity(e.target.value); } })] }), _jsxs("div", { className: "grid grid-cols-1 items-start gap-2 sm:grid-cols-2 sm:items-center sm:gap-4", children: [_jsx("label", { className: "font-medium text-xs", children: "Postcode" }), _jsx("input", { type: "text", name: "postcode", className: "border border-[#B5B5C3] rounded-sm text-xs py-2 px-4", placeholder: "Enter postcode (optional)", value: postcode, onChange: function (e) { return setPostcode(e.target.value); } })] }), _jsxs("div", { className: "grid grid-cols-1 items-start gap-2 sm:grid-cols-2 sm:items-center sm:gap-4", children: [_jsxs("label", { className: "font-medium text-xs", children: ["Contact Number", _jsx("span", { className: "text-[#EB5757]", children: "*" })] }), _jsx(PhoneInput, { country: "BN", className: "border border-[#B5B5C3] rounded-md p-3 text-xs text-[#858585]", placeholder: "Enter phone number", international: true, withCountryCallingCode: true, value: phone, onChange: function (e) {
                                                            return setPhone(e);
                                                        } }), _jsx("input", { type: "hidden", value: phone, name: "contact_number" })] }), _jsxs("div", { className: "grid grid-cols-1 items-start gap-2 sm:grid-cols-2 sm:items-center sm:gap-4", children: [_jsx("label", { className: "font-medium text-xs", children: "Photo / Banner" }), _jsx("input", { type: "file", name: "image", className: "text-xs" })] })] })), type === 2 && (_jsxs("div", { className: "grid grid-cols-1 items-start gap-2 sm:grid-cols-2 sm:items-center sm:gap-4", children: [_jsxs("label", { className: "font-medium text-xs", children: ["Website URL", _jsx("span", { className: "text-[#EB5757]", children: "*" })] }), _jsx("input", { type: "text", name: "reference", className: "border border-[#B5B5C3] rounded-sm text-xs py-2 px-4", placeholder: "Enter website" })] })), _jsxs("div", { className: "grid grid-cols-1 items-start gap-2 sm:grid-cols-2 sm:items-center sm:gap-4", children: [_jsxs("label", { className: "font-medium text-xs", children: ["Status", _jsx("span", { className: "text-[#EB5757]", children: "*" })] }), _jsxs("div", { className: "space-y-2", children: [_jsxs("select", { name: "status", className: "w-full border border-[#B5B5C3] rounded-sm text-xs py-2 px-4", required: true, children: [_jsx("option", { value: 0, children: "Inactive" }), _jsx(CanAccess, { allowed_level: [Roles.Owner], children: _jsx("option", { value: 1, children: "Active" }) })] }), _jsx("p", { className: "text-xs", children: "Status `Active` is only available for Owner role." })] })] })] }), _jsx("button", { type: "submit", className: "mx-5 mt-6 py-3 px-16 font-medium rounded-sm bg-[#CBEDEC] border border-[#1BC5BD] text-[#1BC5BD] text-xs", children: "Create Store" })] })] }) }) }));
}
